// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speaker2023{
    display: grid;
    grid-template-columns:repeat(5,1fr);
    gap: 1rem;
    z-index: 2;
    width: 100%;
}
.speaker23Div{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    width: 100%; 
}
.speakerimg23{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0.1rem 0.1rem;
    box-sizing: border-box;
    border-radius: 50%;
    border: none;
    margin: 0.1rem 0.1rem;
}
.speakerimg23>img{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 50%;
    background-color: white;
    border: 1px solid transparent;
    box-sizing: border-box;
}
.speaker23Div>h5{
    text-align: center;
}
.detailsBelow{
    text-align: center;
    height: 5rem;

}


@media only screen and (max-width: 1200px) {
    .speaker2023{
        grid-template-columns:repeat(4,1fr);
    }
    .speakerimg23{
        border: 2px solid transparent;
    }
    .speaker23Div>p{
        height: 3rem;
        margin-bottom: 0.5rem;
    }
}
@media only screen and (max-width: 700px) {
    .speaker2023{
        grid-template-columns:repeat(3,1fr);
    }
}
@media only screen and (max-width: 550px) {
    .speaker2023{
        grid-template-columns:repeat(3,1fr);

    }
    .speakerimg23{
        border: 2px solid transparent;
    }
    .speaker23Div>p{
        height: 3rem;
        margin-bottom: 0.8rem;
    }
}
@media only screen and (max-width: 450px) {
    .speaker2023{
        grid-template-columns:repeat(2,1fr);
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/SpeakerList/SpeakerList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mCAAmC;IACnC,SAAS;IACT,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;;AAEhB;;;AAGA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,mCAAmC;IACvC;AACJ;AACA;IACI;QACI,mCAAmC;;IAEvC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,mCAAmC;IACvC;AACJ","sourcesContent":[".speaker2023{\n    display: grid;\n    grid-template-columns:repeat(5,1fr);\n    gap: 1rem;\n    z-index: 2;\n    width: 100%;\n}\n.speaker23Div{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    width: 100%; \n}\n.speakerimg23{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 0.1rem 0.1rem;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: none;\n    margin: 0.1rem 0.1rem;\n}\n.speakerimg23>img{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    border-radius: 50%;\n    background-color: white;\n    border: 1px solid transparent;\n    box-sizing: border-box;\n}\n.speaker23Div>h5{\n    text-align: center;\n}\n.detailsBelow{\n    text-align: center;\n    height: 5rem;\n\n}\n\n\n@media only screen and (max-width: 1200px) {\n    .speaker2023{\n        grid-template-columns:repeat(4,1fr);\n    }\n    .speakerimg23{\n        border: 2px solid transparent;\n    }\n    .speaker23Div>p{\n        height: 3rem;\n        margin-bottom: 0.5rem;\n    }\n}\n@media only screen and (max-width: 700px) {\n    .speaker2023{\n        grid-template-columns:repeat(3,1fr);\n    }\n}\n@media only screen and (max-width: 550px) {\n    .speaker2023{\n        grid-template-columns:repeat(3,1fr);\n\n    }\n    .speakerimg23{\n        border: 2px solid transparent;\n    }\n    .speaker23Div>p{\n        height: 3rem;\n        margin-bottom: 0.8rem;\n    }\n}\n@media only screen and (max-width: 450px) {\n    .speaker2023{\n        grid-template-columns:repeat(2,1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
